'use client'

// import { MdOutlineMessage } from "react-icons/md"

export default function TicketForm() {
  return (
    <div className="p-6 rounded-lg shadow-sm bg-[#FFFBF5] border border-[#CAC3BB]">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-xl font-semibold text-gray-900">Ticket Details</h1>
        <button className="bg-[#0c4a6e] text-white px-4 py-2 rounded hover:bg-[#075985] transition-colors">
          Edit Ticket
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-9 gap-y-6">
        {/* Left Column */}
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Lead Type</label>
            <div className="flex items-center">
              <input 
                type="text" 
                value="Study Visa For University of Sydney, Australia" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Date</label>
            <div className="flex items-center">
              <input 
                type="text" 
                value="04/01/25" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Full Name</label>
            <div className="flex items-center">
              <input 
                type="text" 
                value="Farukh Zaman" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Gender</label>
              <input 
                type="text" 
                value="Male" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Age</label>
              <input 
                type="text" 
                value="24" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Marital Status</label>
              <input 
                type="text" 
                value="Unmarried" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Address</label>
            <div className="flex items-center">
              <input 
                type="text" 
                value="House No. 427, Street 12, F-11/4" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">City</label>
              <input 
                type="text" 
                value="Islamabad" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Country</label>
              <input 
                type="text" 
                value="Pakistan" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Zip Code</label>
              <input 
                type="text" 
                value="45200" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Mobile No.</label>
              <input 
                type="text" 
                value="+92 323 998 746" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Email Address</label>
            <input 
              type="email" 
              value="farukhzaman@email.com" 
              readOnly
              className="w-full p-2 border rounded-md text-gray-700"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Confirm Email</label>
            <input 
              type="email" 
              value="farukhzaman@email.com" 
              readOnly
              className="w-full p-2 border rounded-md text-gray-700"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Employment Type</label>
              <input 
                type="text" 
                value="Unemployed" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Job Title</label>
              <input 
                type="text" 
                value="" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Inquiry Type</label>
            <input 
              type="text" 
              value="Walk in" 
              readOnly
              className="w-full p-2 border rounded-md text-gray-700"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Assign Agent</label>
            <input 
              type="text" 
              value="Wasim Khalid" 
              readOnly
              className="w-full p-2 border rounded-md text-gray-700"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Country</label>
            <input 
              type="text" 
              value="Australia" 
              readOnly
              className="w-full p-2 border rounded-md text-gray-700"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Institute Name</label>
            <input 
              type="text" 
              value="University of South Asia" 
              readOnly
              className="w-full p-2 border rounded-md text-gray-700"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Program Name</label>
            <input 
              type="text" 
              value="Master in Business Administration | MBA" 
              readOnly
              className="w-full p-2 border rounded-md text-gray-700"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Offer Letter Status</label>
            <input 
              type="text" 
              value="Received" 
              readOnly
              className="w-full p-2 border rounded-md text-gray-700"
            />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Offer Letter Uploaded</label>
            <div className="flex items-center">
              <input 
                type="text" 
                value="Uploaded" 
                readOnly
                className="w-full p-2 border rounded-md text-gray-700"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

